<template>
  <div class="esop-amount-form">
    <div class="balance-card">
      <div class="balance-icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.5 8.33333V5C17.5 4.08333 16.75 3.33333 15.8333 3.33333H4.16667C3.25 3.33333 2.5 4.08333 2.5 5V15C2.5 15.9167 3.25 16.6667 4.16667 16.6667H15.8333C16.75 16.6667 17.5 15.9167 17.5 15V11.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17.5 8.33333H12.5C11.5833 8.33333 10.8333 9.08333 10.8333 10C10.8333 10.9167 11.5833 11.6667 12.5 11.6667H17.5V8.33333Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="balance-info">
        <span class="balance-label">Available Cash</span>
        <span class="balance-amount">{{ formatAmountToDollar(tradingBalance, 2, "USD") }}</span>
      </div>
    </div>

    <form class="trade-form" @submit.prevent="storeData">
      <div class="form-section">
        <div class="section-header">
          <label class="section-label">Number of Shares</label>
          <span class="section-hint">Enter the amount you want to buy</span>
        </div>
        <TradeNumberInput
          v-if="currentEsop"
          placeHolder="0"
          label="Number of Shares"
          :amount="payload.amount"
          :maxNumber="currentEsop.supply"
          :checkValidity="amountValid"
          :disabled="tokenInputDisabled"
          type="text"
          fieldType="amount"
          name="shareAmount"
          id="shareAmount"
          @set="setShareAmount"
          @valid="shareAmountValid"
          @validate="validate"
        />
      </div>

      <div class="convert-divider">
        <div class="divider-line"></div>
        <div class="convert-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 4.16667V15.8333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.8333 10L10 15.8333L4.16667 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="divider-line"></div>
      </div>

      <div class="form-section">
        <div class="section-header">
          <label class="section-label">Unit Price (USD)</label>
          <label class="market-price-toggle">
            <input
              value="use market price"
              id="useMarketPrice"
              name="option"
              type="checkbox"
              @click="setOption"
            />
            <span class="toggle-text">Use Market Price</span>
            <span class="market-price">
              {{ formatAmountToDollar(currentEsop?.valuation / currentEsop?.total_supply, 2, "USD") }}
            </span>
          </label>
        </div>
        <TradeNumberInput
          placeHolder="0.00"
          label="unit price"
          :amountRequired="payload.price"
          :checkValidity="priceValid"
          :disabled="priceInputDisabled"
          type="text"
          fieldType="amountRequired"
          name="unitPrice"
          id="unitPrice"
          @set="setUnitPrice"
          @valid="unitPriceValid"
          @validate="validate"
        />
      </div>

      <div class="summary-card">
        <div class="summary-header">
          <span class="summary-label">You will receive</span>
        </div>
        <div class="summary-content">
          <div class="token-info" v-if="tradeType === 'Buy'">
            <div class="token-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="8.5" stroke="currentColor" stroke-width="1.5"/>
                <path d="M10 5.83333V14.1667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M7.08333 8.33333C7.08333 7.41667 7.91667 6.66667 10 6.66667C12.0833 6.66667 12.9167 7.41667 12.9167 8.33333C12.9167 9.25 12.0833 10 10 10C7.91667 10 7.08333 10.75 7.08333 11.6667C7.08333 12.5833 7.91667 13.3333 10 13.3333C12.0833 13.3333 12.9167 12.5833 12.9167 11.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <div class="token-details">
              <span class="token-amount">{{ convertToLocale(Number(payload.amount) || 0) }}</span>
              <span class="token-name">{{ currentEsop?.token?.name || currentEsop?.name }} tokens</span>
            </div>
          </div>
          <div class="token-info" v-if="tradeType === 'Sell'">
            <div class="token-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="8.5" stroke="currentColor" stroke-width="1.5"/>
                <path d="M10 5.83333V14.1667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M7.08333 8.33333C7.08333 7.41667 7.91667 6.66667 10 6.66667C12.0833 6.66667 12.9167 7.41667 12.9167 8.33333C12.9167 9.25 12.0833 10 10 10C7.91667 10 7.08333 10.75 7.08333 11.6667C7.08333 12.5833 7.91667 13.3333 10 13.3333C12.0833 13.3333 12.9167 12.5833 12.9167 11.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <div class="token-details">
              <span class="token-amount">{{ formatAmountToDollar(payload.price * payload.amount, 2, "USD") }}</span>
              <span class="token-name">Total value</span>
            </div>
          </div>
        </div>
      </div>

      <button type="submit" class="btn-primary">
        {{ btnTitle }}
      </button>
    </form>

    <Teleport to="#teleport-modal">
      <SmallModal
        v-if="showInfoModal"
        class="tw-z-50"
        @close="showInfoModal = !showInfoModal"
      >
        <template v-slot:content>
          <SecondaryTradeInfoModal
            header="You are about to trade using Advanced Trading"
            subHeader=""
            :details="markeadvanceTradeInfo"
            type="marketTrade"
            @close="closeInfoModal"
          />
        </template>
      </SmallModal>
    </Teleport>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import TradeNumberInput from "@/components/employeesBenefit/trade/TradeNumberInput.vue";
import PinConfirmation from "@/components/general/PinConfirmation.vue";
import SecondaryTradeInfoModal from "@/components/employeesBenefit/trade/SecondaryTradeInfoModal.vue";
import SmallModal from "@/components/general/SmallModal.vue";
import { formatAmountToDollar, convertToLocale } from "@/utils/helpers";
import { setItem } from "@/utils/storage.js";

export default {
  name: "EsopAmountForm",

  emits: ["storeData", "tradeType"],

  components: {
    TradeNumberInput,
    PinConfirmation,
    SecondaryTradeInfoModal,
    SmallModal,
  },

  props: {
    currentEsop: { type: Object, default: () => {}, required: true },
  },

  data() {
    return {
      priceInputDisabled: false,
      tokenInputDisabled: false,
      showInfoModal: false,
      amountValid: false,
      priceValid: false,
      tradeAllShares: false,
      useMarketPrice: false,
      validInput: {
        amount: false,
        price: false,
      },
      payload: {
        amount: "",
        price: "",
      },
      btnTitle: "",
      tradeType: "Buy",
      markeadvanceTradeInfo: [
        {
          text: "Buying or selling token is not instant.",
        },
        {
          text: "Your order will be executed at the price you specified or more. Never less.",
        },
        {
          text: "Your buy/sell request will be added to a list and you will be credited when someone accepts your order.",
        },
      ],
    };
  },

  computed: {
    ...mapState({
      tradingBalance: (state) => state.organisationModule.tradeBalance,
    }),

    maxBuyToken() {
      let maxNumber = 0;
      maxNumber = (this.tradingBalance / this.payload.price).toFixed(2);
      if (maxNumber === "NaN" || maxNumber === "Infinity")
        return 10000000000000;
      return Number(maxNumber);
    },
  },

  mounted() {
    this.btnTitle = `${this.tradeType} ${this.currentEsop?.name}`;
    this.getWalletBalance();
  },

  methods: {
    ...mapActions("organisationModule", ["getWalletBalance"]),

    formatAmountToDollar,
    convertToLocale,

    storeData() {
      this.amountValid = true;
      this.priceValid = true;
      setTimeout(() => {
        if (!this.validInput.amount || !this.validInput.price) return;
        let id = this.currentEsop.token?._id;
        this.payload.id = id;
        setItem("esopPayload", this.payload);
        this.showInfoModal = !this.showInfoModal;
      }, 500);
    },

    closeInfoModal() {
      this.$emit("storeData", "esopAmountForm");
      this.$emit("tradeType", this.tradeType);
      this.showInfoModal = !this.showInfoModal;
    },

    switchTradeType(tradeType) {
      this.tradeType = tradeType;
      this.btnTitle = `${this.tradeType} ${this.currentEsop.token?.name}`;
      this.payload.amount = "";
      this.payload.price = "";
    },

    setOption(event) {
      switch (event.target.value) {
        case "use market price":
          setTimeout(() => {
            this.payload.price = String(
              this.currentEsop?.valuation / this.currentEsop?.total_supply
            );
            this.priceInputDisabled = !this.priceInputDisabled;
            this.useMarketPrice = !this.useMarketPrice;
            this.priceValid = true;
            if (!this.useMarketPrice) this.payload.price = "";
          }, 500);
          break;

        default:
          break;
      }
    },

    setShareAmount(amount) {
      this.payload.amount = amount;
    },

    setUnitPrice(amount) {
      this.payload.price = amount;
    },

    shareAmountValid(valid) {
      this.validInput.amount = valid;
    },

    unitPriceValid(valid) {
      this.validInput.price = valid;
    },

    validate() {
      this.amountValid = false;
      this.priceValid = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.esop-amount-form {
  padding: 24px;
}

.balance-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(135deg, #EEF2FF 0%, #F8FAFC 100%);
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  margin-bottom: 28px;
}

.balance-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 10px;
  color: #4D84FF;
  box-shadow: 0 2px 8px rgba(77, 132, 255, 0.12);
}

.balance-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.balance-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.balance-amount {
  font-family: 'DM Sans', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: #0F172A;
}

.trade-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.section-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.section-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #0F172A;
}

.section-hint {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  color: #64748B;
}

.market-price-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-top: 4px;

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    accent-color: #4D84FF;
    cursor: pointer;
  }

  .toggle-text {
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    color: #64748B;
  }

  .market-price {
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: #4D84FF;
    padding: 2px 8px;
    background: #EEF2FF;
    border-radius: 4px;
  }
}

.convert-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 4px 0;
}

.divider-line {
  flex: 1;
  height: 1px;
  background: #E2E8F0;
}

.convert-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 50%;
  color: #64748B;
}

.summary-card {
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 16px;
}

.summary-header {
  margin-bottom: 12px;
}

.summary-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.summary-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.token-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.token-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  color: #4D84FF;
}

.token-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.token-amount {
  font-family: 'DM Sans', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #0F172A;
}

.token-name {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  color: #64748B;
}

.btn-primary {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #4D84FF;
  border: none;
  border-radius: 10px;
  font-family: 'DM Sans', sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: white;
  cursor: pointer;
  transition: background 0.2s ease;
  margin-top: 8px;

  &:hover {
    background: #3A6FE8;
  }
}
</style>
